export function getUrlKey(name, url) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

export function getQueryParams(url) {
    url = url.split('+').join(' ');
    var params = {},
        tokens,
        re = /[?|&]([^=]+)=([^&]*)/g;

    while (tokens = re.exec(url)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
}

export function isKeyEmpty(value) {
    return value === undefined || value === null || value === '';
}

export function getAndroidDownUrl(name, channels) {
    if (!isKeyEmpty(channels)) {
        for (let i = 0; i < channels.length; i++) {
            if (channels[i].name === name) {
                if (channels[i].anddown) {
                    return channels[i].anddown;
                }
            }
        }
    }
    return "";
}

export function getIosDownUrl(name, channels) {
    if (!isKeyEmpty(channels)) {
        for (let i = 0; i < channels.length; i++) {
            if (channels[i].name === name) {
                if (channels[i].iosdown) {
                    return channels[i].iosdown;
                }
            }
        }
    }
    return "";
}
